import { Product } from 'even-ts-static'
import * as React from 'react'
import { connect } from 'react-redux'

import { CoApplicantAddressMatch, Field } from 'embed/constants'
import { Fields } from 'embed/constants/fields'
import { uiShowCoApplicantAddressFieldsSelector } from 'embed/selectors/ui'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationField } from 'embed/components/ApplicationField/container'
import Wrapper from '../Wrapper'

export interface OwnProps {
  directReferral: boolean
  dispatchBackToStepOne: () => void
  handleChangeAndContinue: (field: Field, value: string) => void
  onBack: () => void
  onChange: (field: Field, value) => void
  onContinue: () => void
  onEnter?: () => void
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
}

export interface StoreProps {
  showCoApplicantAddressFields: boolean
}

export type Props = OwnProps & StoreProps

export const StepbystepApplicationStepCoApplicantAddressToggle: React.SFC<Props> = (props) => {
  const onChange = (value) => {
    if (value === CoApplicantAddressMatch.DifferentFromApplicant) {
      props.onChange(Fields.CoApplicantAddressMatchButtonList, value)
    } else {
      props.handleChangeAndContinue(Fields.CoApplicantAddressMatchButtonList, value)
    }
  }

  return (
    <Wrapper {...props}>
      <StepTitle>What’s your co-applicant’s address?</StepTitle>
      <ApplicationField onChange={onChange} product={Product.Loan} field={Fields.CoApplicantAddressMatchButtonList} />
      {props.showCoApplicantAddressFields === true && (
        <>
          <ApplicationField product={Product.Loan} field={Fields.CoApplicantAddressOne} onEnter={props.onEnter} />
          <ApplicationField product={Product.Loan} field={Fields.CoApplicantAddressTwo} onEnter={props.onEnter} />
          <ApplicationField product={Product.Loan} field={Fields.CoApplicantZipcode} onEnter={props.onEnter} />
          <ApplicationField product={Product.Loan} field={Fields.CoApplicantCity} onEnter={props.onEnter} />
          <ApplicationField product={Product.Loan} field={Fields.CoApplicantState} onEnter={props.onEnter} />
        </>
      )}
    </Wrapper>
  )
}

const mapStateToProps = (state) => ({ showCoApplicantAddressFields: uiShowCoApplicantAddressFieldsSelector(state) })

export default connect(mapStateToProps)(StepbystepApplicationStepCoApplicantAddressToggle)
